import {
  getAvailableLendersByLenderCommissions,
  getPreferredProduct
} from '__core/shared/util/salestrekker';
import template from './ticketEditDeleteContact.template.html';

/* @ngInject */

export default (
  $q,
  $rootScope,
  $scope,
  $state,
  $stateParams,
  $timeout,
  $mdDialog,
  cookies,
  webpage,
  authenticationService,
  dateTimeService,
  uiService,
  navigationService,
  eventService,
  changesService,
  jsonFactory,
  workflowService,
  ticketService,
  ticketsService,
  accountsService,
  partnersService,
  contactsService,
  contactService,
  incomeService,
  assetsService,
  liabilitiesService,
  fieldsService,
  homeLoanService,
  assetFinanceService,
  Ticket,
  Field,
  FieldEntity,
  HomeLoan,
  TicketTitleDetail,
  TicketLoanSecuritySplit,
  TicketLoanDetailsSplit,
  LabelType,
  TicketAssetFinance,
  TicketHomeLoan,
  TicketInsurance,
  TicketCommercialLoan,
  TicketCommercialLoanSecuritySplit,
  TicketCommercialLoanSecuritySplitType,
  TicketPersonalLoan,
  TicketConveyancingLoan,
  TicketRealEstate,
  TicketLoanPropertySplit,
  TicketLoanFee,
  TicketLoanFeeType,
  workflowEditService,
  labelsService,
  AssetFinance,
  AssetFinanceDetail,
  helperService,
  organizationService,
  lendersService,
  ACCOUNT,
  CONTACT,
  GOOGLEMAPS
) => {
  $scope.Model = {
    countries: [],
    vat: $rootScope.CurrentOrganization?.organization?.vat
      ? _.divide($rootScope.CurrentOrganization.organization.vat, 100)
      : 0,
    organizationCountry: helperService.getOrganizationCountry()?.cca2,
    currentWorkflow: {},
    currentTicket: {},
    currentTicketOwner: {},
    currentTicketLoan: {},
    availableAccounts: [],
    availablePartners: [],
    availableContacts: [],
    availableContactClients: [],
    availableContactNonClients: [],
    ticketContacts: [],
    ticketPartners: [],
    ticketAccountsAsPartners: [],
    availableLabels: [],
    availableTicketLabels: [],
    availableContactLabels: [],
    allLenders: [],
    availableLenders: [],
    availableFields: [],
    currentTeamMembers: [],
    selectedItem: null,
    searchText: null,
    incomeTypesAvailable: incomeService.getAvailableIncomeTypes(),
    assetTypesAvailable: assetsService.getAvailableAssetTypes(),
    liabilityTypesAvailable: liabilitiesService.getAvailableLiabilityTypes(),
    currentDateFormat: $rootScope.CurrentDateFormatPrimary(),
    availableSections: ['dealInformation', 'labels', 'customFields'],
    activeSection: 'dealInformation',
    options: {
      show: {
        subTitle: true,
        delete: true
      }
    },
    isSidebarMinimized: cookies.get('stSidebar') || false,
    googleAutocompleteOptions: {
      componentRestrictions: GOOGLEMAPS.restrictToCountries
    },
    isTicketContactReady: false,
    isProcessing: false,
    isNew: $stateParams.dd === '0',
    isSaveReady: false,
    isReady: false
  };

  $rootScope.$on('$stateChangeStart', (ev, toState, toParams) => {
    $scope.Model.toState = toState;
    $scope.Model.toParams = toParams;
  });

  /*
   * Set webpage Title
   * --------------------------------------------------------------------------------
   */
  webpage.pageTitle('Loading, please wait');

  /*
   * Methods
   * --------------------------------------------------------------------------------
   */
  const loadCountries = () => {
    const deferred = $q.defer();
    jsonFactory.getCountries().then((data) => {
      $scope.Model.countries = data;
      deferred.resolve(data);
    });
    return deferred.promise;
  };

  const loadWorkflow = (idWorkflow) => {
    const deferred = $q.defer();
    workflowService.readWorkflow({ id: idWorkflow }).then((workflow) => {
      $scope.Model.currentWorkflow = workflow;
      deferred.resolve(workflow);
    });
    return deferred.promise;
  };

  const loadTicket = (idTicket) => {
    const deferred = $q.defer();
    if ($scope.Model.isNew) {
      $scope.Model.currentTicket = Ticket.blank();
      deferred.resolve($scope.Model.currentTicket);
    } else {
      ticketService.readTicket({ id: idTicket }).then((ticket) => {
        $scope.Model.currentTicket = ticket;
        deferred.resolve(ticket);
      });
    }
    return deferred.promise;
  };

  const loadLabels = () => {
    labelsService
      .getAvailable({
        orderBy: 'name',
        coerceTo: 'string',
        isDescending: false,
        isActive: true
      })
      .then((labels) => {
        $scope.Model.availableLabels = labels;
        $scope.Model.availableTicketLabels = _.filter(
          labels,
          (l) => l?.type?.name === LabelType.ticket.name
        );
        $scope.Model.availableContactLabels = helperService.sortContactLabels({
          labels: _.filter(labels, (l) => l?.type?.name === LabelType.contact.name)
        });
      });
  };

  const loadFields = () => {
    fieldsService
      .getAvailable({ entity: FieldEntity.ticket.name, isActive: true })
      .then((fields) => {
        $scope.Model.availableFields = fields;
      });
  };

  const loadAccounts = (idAccounts) => {
    const deferred = $q.defer();
    accountsService
      .getSpecific({ ids: idAccounts, isActive: true, fields: ACCOUNT.FIELDS.LIST })
      .then((accounts) => {
        if (accounts && accounts.length) {
          $scope.Model.availableAccounts = accounts;
          $scope.Model.currentTeamMembers = _.filter(
            accounts || [],
            (a) => _.indexOf($scope.Model.currentTicket?.idTeamMembers || [], a?.id) > -1
          );
          $scope.Model.currentTicketOwner = _.find(
            accounts || [],
            (a) => a?.id === $scope.Model.currentTicket?.idOwner
          );
          if (!$scope.Model.currentTicketOwner) {
            let account = accounts[0];
            if ($scope.Model.isNew) {
              let idx = -1;
              if (
                _.indexOf(
                  $scope.Model.currentWorkflow?.idTeamMembers || [],
                  $rootScope.CurrentAccount.id
                ) > -1
              ) {
                idx = _.findIndex(
                  accounts || [],
                  (a) => a?.id === $rootScope.CurrentAccount?.id
                );
              }
              if (idx > -1) {
                account = accounts[idx];
              }
              $scope.Model.currentTicketOwner = account;
            } else {
              $scope.Model.currentTicketOwner = account;
            }
          }
        }
        deferred.resolve(accounts);
      });
    return deferred.promise;
  };

  const loadPartners = () => {
    partnersService
      .getAvailable({ isActive: true, fields: ACCOUNT.FIELDS.CHIPS })
      .then((partners) => {
        $scope.Model.availablePartners = partners;
      });
  };

  const loadContacts = (idContacts) => {
    const deferred = $q.defer();
    contactsService
      .getSpecific({
        idContacts,
        isActive: true,
        fields: !$scope.Model.currentWorkflow.isAssetFinance() ? CONTACT.FIELDS.WTF_LIST : ''
      })
      .then((contacts) => {
        const availableContacts = _.compact(contacts);
        $scope.Model.availableContacts = availableContacts;
        $scope.Model.availableContactClients = _.compact(
          _.sortBy(
            _.filter(
              availableContacts,
              (client) => _.indexOf($scope.Model.currentTicket?.idClients, client?.id) > -1
            ),
            (c) => _.indexOf($scope.Model.currentTicket?.idClients || [], c?.id)
          )
        );
        $scope.Model.availableContactNonClients = _.compact(
          _.sortBy(
            _.filter(
              availableContacts,
              (client) => _.indexOf($scope.Model.currentTicket?.idContacts, client?.id) > -1
            ),
            (c) => _.indexOf($scope.Model.currentTicket?.idContacts || [], c?.id)
          )
        );
        deferred.resolve(availableContacts);
      });
    return deferred.promise;
  };

  const loadHomeLoan = (idLoan) => {
    const deferred = $q.defer();
    homeLoanService.readHomeLoan({ id: idLoan }).then((loan) => {
      $scope.Model.currentHomeLoan = loan;
      deferred.resolve(loan);
    });
    return deferred.promise;
  };

  const loadAssetFinance = (idAssetFinance) => {
    const deferred = $q.defer();
    assetFinanceService.readAssetFinance({ id: idAssetFinance }).then((assetFinance) => {
      $scope.Model.currentAssetFinance = assetFinance;
      deferred.resolve(assetFinance);
    });
    return deferred.promise;
  };

  const loadLenders = (account) => {
    const deferred = $q.defer();
    let lenderType = '';
    if ($scope.Model.currentWorkflow?.isHomeLoan()) {
      lenderType = 'RESIDENTIAL';
    } else if ($scope.Model.currentWorkflow?.isAssetFinance()) {
      lenderType = 'ASSET_FINANCE';
    } else if ($scope.Model.currentWorkflow?.isCommercialLoan()) {
      lenderType = 'COMMERCIAL';
    } else if ($scope.Model.currentWorkflow?.isPersonalLoan()) {
      lenderType = 'PERSONAL';
    }
    if (lenderType !== '') {
      $q.all([
        organizationService.readOrganization({ id: $rootScope.CurrentOrganization?.id }),
        lendersService.getAvailable({
          cca2: [$scope.Model.organizationCountry],
          type: lenderType
        }),
        $scope.Model.currentTicket?.idAssetFinance
          ? assetFinanceService.readAssetFinance({
              id: $scope.Model.currentTicket?.idAssetFinance,
              fields: {
                list: ['isCommercial']
              }
            })
          : {}
      ]).then((data) => {
        const organization = data[0];
        const lenders = data[1];
        const assetFinance = data[2];
        $scope.Model.allLenders = _.chain(lenders)
          .sortNatural('name')
          .sortNatural('group')
          .value();

        const availableLenders = getAvailableLendersByLenderCommissions(
          lenders,
          organization,
          account,
          $scope.Model.currentWorkflow,
          $rootScope.IsEnterprise,
          assetFinance?.isCommercial || false
        );
        $scope.Model.availableLenders = _.chain(availableLenders)
          .sortNatural('name')
          .sortNatural('group')
          .value();
        deferred.resolve(lenders);
      });
    } else {
      deferred.resolve([]);
    }
    return deferred.promise;
  };

  const buildTicketType = () => {
    if (
      $scope.Model.currentWorkflow?.isAssetFinance() &&
      _.isEmpty($scope.Model.currentTicket?.assetFinance)
    ) {
      $scope.Model.currentTicket.assetFinance = TicketAssetFinance.blank();
    }
    if (
      $scope.Model.currentWorkflow?.isInsurance() &&
      _.isEmpty($scope.Model.currentTicket?.insurance)
    ) {
      $scope.Model.currentTicket.insurance = TicketInsurance.blank();
    }
    if (
      $scope.Model.currentWorkflow?.isHomeLoan() &&
      _.isEmpty($scope.Model.currentTicket?.loan) &&
      !$scope.hasHomeLoanTools()
    ) {
      $scope.Model.currentTicket.loan = TicketHomeLoan.blank();
    }
    if (
      $scope.Model.currentWorkflow?.isCommercialLoan() &&
      _.isEmpty($scope.Model.currentTicket?.commercialLoan)
    ) {
      $scope.Model.currentTicket.commercialLoan = TicketCommercialLoan.blank();
    }
    if (
      $scope.Model.currentWorkflow?.isPersonalLoan() &&
      _.isEmpty($scope.Model.currentTicket?.personalLoan)
    ) {
      $scope.Model.currentTicket.personalLoan = TicketPersonalLoan.blank();
    }
    if (
      $scope.Model.currentWorkflow?.isConveyancing() &&
      _.isEmpty($scope.Model.currentTicket?.conveyancing)
    ) {
      $scope.Model.currentTicket.conveyancing = TicketConveyancingLoan.blank();
    }
    if (
      $scope.Model.currentWorkflow?.isRealEstate() &&
      _.isEmpty($scope.Model.currentTicket?.realEstate)
    ) {
      $scope.Model.currentTicket.realEstate = TicketRealEstate.blank();
      $scope.Model.currentTicket.realEstate.dealRealEstatePropertySplit = [
        TicketLoanPropertySplit.blank()
      ];
      const titleDetail = TicketTitleDetail.blank();
      titleDetail.idSecurity = titleDetail.id;
      $scope.Model.currentTicket.realEstate.titleDetails.push(titleDetail);
    }
  };

  const initialize = () => {
    loadPartners();
    loadLabels();
    loadFields();
    loadCountries().then(() => {
      loadWorkflow($stateParams.id).then(() => {
        loadTicket($stateParams.dd).then(() => {
          webpage.pageTitle(
            $scope.Model.isNew
              ? 'Add New Ticket'
              : `Edit Ticket ${$scope.Model.currentTicket.getName()}`
          );

          const idAccounts = _.uniq(
            _.compact(
              _.union(
                [$scope.Model.currentTicket?.idOwner],
                [$scope.Model.currentWorkflow?.idOwner],
                $scope.Model.currentWorkflow?.idTeamMembers
              )
            )
          );

          if (idAccounts?.length) {
            loadAccounts(idAccounts).then(() => {
              loadLenders($scope.Model.currentTicketOwner).then(() => {
                buildTicketType();

                if ($scope.Model.isNew) {
                  $scope.Model.currentTicket.idOwner = $scope.Model.currentTicketOwner?.id;
                  $scope.Model.currentTicket.idWorkflow = $scope.Model.currentWorkflow?.id;
                  $scope.Model.currentTicket.idStage =
                    $scope.Model.currentWorkflow.stages[0].id;
                  $scope.Model.currentTicket.values.onceOffDueDate =
                    !$scope.Model.currentWorkflow.isAssetFinance() &&
                    !$scope.Model.currentWorkflow.isInsurance() &&
                    !$scope.Model.currentWorkflow.isPersonalLoan()
                      ? parseInt(moment.utc().startOf('day').add(1, 'month').format('X'), 10)
                      : parseInt(moment.utc().startOf('day').add(7, 'days').format('X'), 10);
                }

                dateTimeService.getSet(
                  $scope,
                  $scope.Model.currentTicket,
                  'values.onceOffDueDate',
                  'getSetOnceOffDueDate'
                );
                dateTimeService.getSet(
                  $scope,
                  $scope.Model.currentTicket,
                  'values.financeDueDate',
                  'getSetFinanceDueDate'
                );

                const idContacts = _.uniq(
                  _.compact(
                    _.union(
                      $scope.Model.currentTicket?.idClients,
                      $scope.Model.currentTicket?.idContacts
                    )
                  )
                );
                loadContacts(idContacts).then(() => {
                  const availableContacts = $scope.Model.availableContactClients.concat(
                    $scope.Model.availableContactNonClients
                  );
                  const cLen = availableContacts?.length || 0;
                  for (let c = 0; c < cLen; c += 1) {
                    const ticketContact = $scope.filledContactDetails(availableContacts[c]);
                    $scope.Model.ticketContacts.push(ticketContact);
                  }
                  $scope.Model.isTicketContactReady = true;

                  if ($scope.Model.currentTicket?.idPartners?.length) {
                    const pLen = $scope.Model.currentTicket?.idPartners?.length || 0;
                    for (let p = 0; p < pLen; p += 1) {
                      $scope.Model.ticketPartners.push({
                        idPartner: $scope.Model.currentTicket.idPartners[p],
                        partnerReferralFee: $scope.Model.currentTicket?.partnersReferralFee
                          ? $scope.Model.currentTicket.partnersReferralFee[
                              $scope.Model.currentTicket.idPartners[p]
                            ]
                          : []
                      });
                    }
                  } else {
                    $scope.ticketPartnerAdd(false);
                  }

                  if ($rootScope.canSeeAccountsAsPartnersOption()) {
                    const pLen = $scope.Model.currentTicket?.idAccountsAsPartners?.length || 0;
                    for (let p = 0; p < pLen; p += 1) {
                      $scope.Model.ticketAccountsAsPartners.push({
                        idPartner: $scope.Model.currentTicket.idAccountsAsPartners[p],
                        partnerReferralFee: $scope.Model.currentTicket.partnersReferralFee
                          ? $scope.Model.currentTicket.partnersReferralFee[
                              $scope.Model.currentTicket.idAccountsAsPartners[p]
                            ]
                          : []
                      });
                    }
                  } else {
                    $scope.ticketPartnerAdd(true);
                  }

                  if ($scope.hasHomeLoanTools()) {
                    if (!$scope.Model.currentTicket?.idLoan) {
                      $scope.contactAdd(false);
                      $scope.Model.currentHomeLoan = HomeLoan.blank();
                      $scope.Model.availableSections.splice(1, 0, 'securityDetails');
                      $scope.isLenderExistingInTicketOwnersLenderAccreditations();
                      $scope.Model.isReady = true;
                    } else {
                      loadHomeLoan($scope.Model.currentTicket.idLoan).then(() => {
                        $scope.Model.availableSections.splice(1, 0, 'securityDetails');
                        $scope.isLenderExistingInTicketOwnersLenderAccreditations();
                        $scope.Model.isReady = true;
                      });
                    }
                  } else if ($scope.hasAssetFinanceTools()) {
                    if (!$scope.Model.currentTicket?.idAssetFinance) {
                      $scope.Model.currentAssetFinance = AssetFinance.blank();
                      if (
                        ($rootScope.isDev() || $rootScope.isNlg() || $rootScope.isPtf()) &&
                        $stateParams?.loanPurpose
                      ) {
                        $scope.Model.currentAssetFinance.isCommercial =
                          $stateParams.loanPurpose === 'commercial' || false;
                        $scope.contactAdd($scope.Model.currentAssetFinance.isCommercial);
                      } else {
                        $scope.contactAdd(true);
                      }
                      $scope.isLenderExistingInTicketOwnersLenderAccreditations();
                      $scope.Model.isReady = true;
                    } else {
                      loadAssetFinance($scope.Model.currentTicket.idAssetFinance).then(() => {
                        $scope.isLenderExistingInTicketOwnersLenderAccreditations();
                        $scope.Model.isReady = true;
                      });
                    }
                  } else {
                    if ($scope.Model.currentWorkflow?.isAssetFinance()) {
                      $scope.Model.availableSections.splice(1, 0, 'assetFinance');
                    } else if (
                      $scope.Model.currentWorkflow?.isInsurance() &&
                      !$rootScope.canSeeInsuranceTools()
                    ) {
                      $scope.Model.availableSections.splice(1, 0, 'insurance');
                    } else if ($scope.Model.currentWorkflow?.isHomeLoan()) {
                      $scope.Model.availableSections.splice(1, 0, 'homeLoan');
                    } else if ($scope.Model.currentWorkflow?.isCommercialLoan()) {
                      $scope.Model.availableSections.splice(1, 0, 'commercialLoan');
                    } else if ($scope.Model.currentWorkflow?.isPersonalLoan()) {
                      $scope.Model.availableSections.splice(1, 0, 'personalLoan');
                    } else if ($scope.Model.currentWorkflow?.isConveyancing()) {
                      $scope.Model.availableSections.splice(1, 0, 'conveyancing');
                    } else if ($scope.Model.currentWorkflow?.isRealEstate()) {
                      $scope.Model.availableSections.splice(1, 0, 'realEstate');
                    }
                    if (!$scope.Model.currentTicket?.id) {
                      $scope.contactAdd(false);
                    }
                    $scope.Model.isReady = true;
                  }
                });
              });
            });
          }
        });
      });
    });
  };

  initialize();

  /*
   * Ticket Edit ~ Helpers
   * --------------------------------------------------------------------------------
   */
  $scope.isDealOwnerBroker = () =>
    authenticationService.isBroker($scope.Model.currentTicket.idOwner);

  $scope.isDealImportedAndNotArchived = () =>
    $scope.Model.currentTicket.isImported
      ? !$scope.Model.currentTicket.isWon &&
        !$scope.Model.currentTicket.isLost &&
        !$scope.Model.currentTicket.isFrozen &&
        $scope.Model.currentTicket.isActive
      : true;

  $scope.toggleCommercial = () => {
    if (
      $scope.Model.currentAssetFinance?.isCommercial &&
      $scope.Model.ticketContacts?.length === 1 &&
      !$scope.Model.ticketContacts[0]?.isCompany &&
      $scope.Model.ticketContacts[0]?.name === '' &&
      $scope.Model.ticketContacts[0]?.familyName === ''
    ) {
      $scope.contactDelete(null, $scope.Model.ticketContacts[0]);
      $scope.contactAdd(true);
    }
    if (
      !$scope.Model.currentAssetFinance?.isCommercial &&
      $scope.Model.ticketContacts?.length === 1 &&
      $scope.Model.ticketContacts[0]?.isCompany &&
      $scope.Model.ticketContacts[0]?.name === ''
    ) {
      $scope.contactDelete(null, $scope.Model.ticketContacts[0]);
      $scope.contactAdd(false);
    }
    $scope.toggleChanges();
  };

  $scope.hasHomeLoanTools = () =>
    $scope.isDealOwnerBroker() &&
    $rootScope.hasBrokerToolsEnabled() &&
    (!$scope.Model.isNew ? $scope.Model.currentTicket.idLoan : true) &&
    $scope.Model.availableLenders.length &&
    $scope.Model.currentWorkflow.isHomeLoan();

  $scope.hasAssetFinanceTools = () =>
    $scope.isDealOwnerBroker() &&
    $rootScope.hasBrokerToolsEnabled() &&
    (!$scope.Model.isNew ? $scope.Model.currentTicket.idAssetFinance : true) &&
    $scope.Model.availableLenders.length &&
    $scope.Model.currentWorkflow.isAssetFinance() &&
    $rootScope.canSeeAssetFinanceTools();

  $scope.getLender = () => {
    let preferredProduct;
    if ($scope.Model.currentWorkflow.isAssetFinance()) {
      preferredProduct = getPreferredProduct(
        $scope.Model.currentAssetFinance?.compareProducts || []
      );
    }
    if ($scope.Model.currentWorkflow.isHomeLoan()) {
      preferredProduct = getPreferredProduct(
        $scope.Model.currentHomeLoan?.reviewProducts || []
      );
    }
    return _.find(
      $scope.Model.availableLenders || [],
      (l) =>
        l?.id ===
        (preferredProduct?.selectedProduct?.lender[0]?.id || preferredProduct?.idLender)
    );
  };

  $scope.haveTicketContacts = () =>
    _.every($scope.Model.ticketContacts || [], (c) =>
      c?.isCompany ? c?.name : c?.name && c?.familyName
    );

  $scope.showError = () =>
    !$scope.Model.currentTicket?.name ||
    !$scope.Model.currentTicket?.idOwner ||
    !$scope.Model.currentTicket?.idStage ||
    !$scope.Model.currentTicket?.values?.onceOffDueDate;

  $scope.canSave = () =>
    !$scope.showError() &&
    $scope.haveTicketContacts() &&
    !$scope.Model.currentTicket?.isSettled &&
    $scope.Model.isSaveReady;

  /*
   * Ticket view ~ Change ticket owner
   * --------------------------------------------------------------------------------
   */
  $scope.ticketChangeOwner = (idAccount) => {
    if (!$scope.Model.currentTicket.isLodged) {
      const ticketOwner = $scope.getAccount(idAccount);
      if (ticketOwner) {
        loadLenders(ticketOwner).then(() => {
          $scope.Model.currentTicket.idOwner = idAccount;
          if (
            $scope.hasHomeLoanTools() &&
            $stateParams.dd === '0' &&
            (!$scope.Model.currentHomeLoan || !$scope.Model.currentHomeLoan?.id)
          ) {
            const hIdx = $scope.Model.availableSections.indexOf('homeLoan');
            $scope.Model.availableSections.splice(hIdx, 1);
            $scope.Model.currentTicket.loan = {};
            $scope.Model.currentHomeLoan = HomeLoan.blank();
            $scope.Model.availableSections.splice(1, 0, 'securityDetails');
          } else if (
            !$scope.hasHomeLoanTools() &&
            $stateParams.dd === '0' &&
            $scope.Model.currentHomeLoan?.id &&
            $scope.Model.currentWorkflow.isHomeLoan()
          ) {
            $scope.Model.currentHomeLoan = undefined;
            $scope.Model.currentTicket.loan = TicketHomeLoan.blank();
            const sIdx = $scope.Model.availableSections.indexOf('securityDetails');
            $scope.Model.availableSections.splice(sIdx, 1);
            $scope.Model.availableSections.splice(1, 0, 'homeLoan');
          } else if (
            $scope.hasHomeLoanTools() &&
            $stateParams.dd !== '0' &&
            $scope.Model.currentTicket &&
            !$scope.Model.currentTicket?.idLoan
          ) {
            $scope.Model.currentHomeLoan = HomeLoan.blank();
            const hIdx = $scope.Model.availableSections.indexOf('homeLoan');
            $scope.Model.availableSections.splice(hIdx, 1);
            $scope.Model.availableSections.splice(1, 0, 'securityDetails');
          } else if (
            (!$scope.hasHomeLoanTools() &&
              $stateParams.dd !== '0' &&
              $scope.Model.currentTicket &&
              !$scope.Model.currentTicket?.idLoan &&
              _.isEmpty($scope.Model.currentHomeLoan)) ||
            (!$scope.hasHomeLoanTools() &&
              $scope.Model.currentTicket &&
              $scope.Model.currentTicket?.idLoan &&
              $scope.Model.currentWorkflow.isHomeLoan())
          ) {
            $scope.Model.currentHomeLoan = undefined;
            if (_.isEmpty($scope.Model.currentTicket.loan)) {
              $scope.Model.currentTicket.loan = TicketHomeLoan.blank();
            }
            const sIdx = $scope.Model.availableSections.indexOf('securityDetails');
            $scope.Model.availableSections.splice(sIdx, 1);
            $scope.Model.availableSections.splice(1, 0, 'homeLoan');
          }

          if (
            $scope.hasAssetFinanceTools() &&
            $stateParams.dd === '0' &&
            (!$scope.Model.currentAssetFinance || !$scope.Model.currentAssetFinance?.id)
          ) {
            const aIdx = $scope.Model.availableSections.indexOf('assetFinance');
            $scope.Model.availableSections.splice(aIdx, 1);
            $scope.Model.currentTicket.assetFinance = {};
            $scope.Model.currentAssetFinance = AssetFinance.blank();
            $scope.toggleCommercial();
          } else if (
            !$scope.hasAssetFinanceTools() &&
            $stateParams.dd === '0' &&
            $scope.Model.currentAssetFinance &&
            $scope.Model.currentAssetFinance?.id &&
            $scope.Model.currentWorkflow.isAssetFinance()
          ) {
            $scope.Model.currentAssetFinance = undefined;
            if (_.isEmpty($scope.Model.currentTicket.assetFinance)) {
              $scope.Model.currentTicket.assetFinance = TicketAssetFinance.blank();
            }
            $scope.Model.availableSections.splice(1, 0, 'assetFinance');
          } else if (
            $scope.hasAssetFinanceTools() &&
            $stateParams.dd !== '0' &&
            !$scope.Model.currentTicket.idAssetFinance &&
            _.isEmpty($scope.Model.currentAssetFinance)
          ) {
            $scope.Model.currentTicket.assetFinance = {};
            $scope.Model.currentAssetFinance = AssetFinance.blank();
            const aIdx = $scope.Model.availableSections.indexOf('assetFinance');
            $scope.Model.availableSections.splice(aIdx, 1);
            $scope.toggleCommercial();
          } else if (
            !$scope.hasAssetFinanceTools() &&
            $stateParams.dd !== '0' &&
            !_.isEmpty($scope.Model.currentAssetFinance) &&
            $scope.Model.currentAssetFinance?.id &&
            $scope.Model.currentWorkflow.isAssetFinance()
          ) {
            $scope.Model.currentAssetFinance = undefined;
            if (_.isEmpty($scope.Model.currentTicket.assetFinance)) {
              $scope.Model.currentTicket.assetFinance = TicketAssetFinance.blank();
            }
            $scope.Model.availableSections.splice(1, 0, 'assetFinance');
          }
          $scope.isLenderExistingInTicketOwnersLenderAccreditations();
          $scope.toggleChanges();
        });
      }
    } else {
      $scope.Model.currentTicket.idOwner = $scope.Model.currentTicketOwner.id;
      uiService.toast({
        text: {
          p1: 'Deal',
          p2: $scope.Model.currentTicket.getName(),
          p3: 'has already been lodged'
        },
        warn: true
      });
    }
  };

  $scope.isLenderExistingInTicketOwnersLenderAccreditations = () => {
    const ticketOwner = $scope.getAccount($scope.Model.currentTicket.idOwner);
    let preferredProduct;
    if (ticketOwner?.lenderAccreditations?.length) {
      if ($scope.hasAssetFinanceTools()) {
        preferredProduct = getPreferredProduct(
          $scope.Model.currentAssetFinance?.compareProducts || []
        );
      }
      if ($scope.hasHomeLoanTools()) {
        preferredProduct = getPreferredProduct(
          $scope.Model.currentHomeLoan?.reviewProducts || []
        );
      }
      if (preferredProduct) {
        let lender;
        if ($rootScope.IsEnterprise) {
          lender = _.find(
            $scope.Model.availableLenders || [],
            (l) =>
              l?.id ===
              (preferredProduct?.selectedProduct?.lender[0]?.id || preferredProduct?.idLender)
          );
        } else {
          lender = _.find(
            ticketOwner?.lenderAccreditations || [],
            (l) =>
              l?.idLender ===
              (preferredProduct?.selectedProduct?.lender[0]?.id || preferredProduct?.idLender)
          );
        }
        return lender !== undefined;
      }
      return true;
    }
    return true;
  };

  $scope.getAccount = (idAccount) =>
    _.find($scope.Model.availableAccounts || [], (a) => a.id === idAccount);

  $scope.hasLenderAccreditations = () => {
    if (
      ($stateParams.dd !== '0' &&
        $scope.Model.currentWorkflow.isAssetFinance() &&
        $scope.Model.currentTicket.idAssetFinance) ||
      ($stateParams.dd !== '0' &&
        $scope.Model.currentWorkflow.isHomeLoan() &&
        $scope.Model.currentTicket.idLoan)
    ) {
      return (account) => {
        let output = [];
        if ($scope.hasHomeLoanTools() || $scope.hasAssetFinanceTools()) {
          if (
            !account?.isDisabled &&
            account?.lenderAccreditations.length &&
            authenticationService.isBroker(account?.id)
          ) {
            const idLenders = _.compact(_.map(account?.lenderAccreditations || [], 'idLender'));
            const idAllLenders = _.compact(_.map($scope.Model.allLenders, 'id'));
            output = _.intersection(idLenders, idAllLenders);
          }
          return output.length > 0;
        }
        return true;
      };
    }
    return (account) => {
      return !account.isDisabled;
    };
  };

  $scope.getToolsName = () => {
    let name = 'tools';
    if ($scope.Model.currentWorkflow.isHomeLoan()) {
      name = 'Broker tools';
    }
    if ($scope.Model.currentWorkflow.isAssetFinance()) {
      name = 'Asset finance tools';
    }
    return name;
  };

  /*
   * Ticket Edit ~ Add/Edit/Delete Partner(s)
   * --------------------------------------------------------------------------------
   */
  $scope.getPartner = (idPartner) => {
    let partner;
    if ($scope.Model.availablePartners.length) {
      partner = $scope.Model.availablePartners.find((p) => p.id === idPartner);
    }
    return partner;
  };

  $scope.ticketPartnerAdd = (isAccountAsPartner) => {
    if (isAccountAsPartner) {
      $scope.Model.ticketAccountsAsPartners.push({ idPartner: '', partnerReferralFee: '' });
    } else {
      $scope.Model.ticketPartners.push({
        idPartner: '',
        partnerReferralFee: ''
      });
    }
  };

  $scope.ticketPartnerDelete = (idPartner, idx, isAccountAsPartner) => {
    if (isAccountAsPartner) {
      $scope.Model.ticketAccountsAsPartners.splice(idx, 1);
      $scope.Model.currentTicket.idAccountsAsPartners.splice(
        $scope.Model.currentTicket.idAccountsAsPartners.indexOf(idPartner),
        1
      );
    } else {
      $scope.Model.ticketPartners.splice(idx, 1);
      $scope.Model.currentTicket.idPartners.splice(
        $scope.Model.currentTicket.idPartners.indexOf(idPartner),
        1
      );
      delete $scope.Model.currentTicket.partnersReferralFee[idPartner];
    }
    $timeout(() => {
      $scope.toggleChanges();
    });
  };

  $scope.ticketPartnerEdit = (idPartner, idx, isAccountAsPartner) => {
    if (
      isAccountAsPartner &&
      _.indexOf($scope.Model.currentTicket?.idAccountsAsPartners || [], idPartner) === -1
    ) {
      $scope.Model.currentTicket.idAccountsAsPartners.push(idPartner);
      if (!$scope?.Model?.currentTicket?.partnersReferralFee) {
        $scope.Model.currentTicket.partnersReferralFee = {};
      }
      $scope.Model.currentTicket.partnersReferralFee[idPartner] = '';
      $scope.Model.ticketAccountsAsPartners[idx].partnerReferralFee = '';
      $timeout(() => {
        $scope.toggleChanges();
      });
    } else if (
      !isAccountAsPartner &&
      _.indexOf($scope.Model.currentTicket?.idPartners || [], idPartner) === -1
    ) {
      $scope.Model.currentTicket.idPartners.push(idPartner);
      if (!$scope?.Model?.currentTicket?.partnersReferralFee) {
        $scope.Model.currentTicket.partnersReferralFee = {};
      }
      $scope.Model.currentTicket.partnersReferralFee[idPartner] = $rootScope.CurrentOrganization
        .partnersAttributes[idPartner]
        ? $rootScope.CurrentOrganization.partnersAttributes[idPartner].fee
        : '';
      $scope.Model.ticketPartners[idx].partnerReferralFee = $rootScope.CurrentOrganization
        .partnersAttributes[idPartner]
        ? $rootScope.CurrentOrganization.partnersAttributes[idPartner].fee
        : '';
      $timeout(() => {
        $scope.toggleChanges();
      });
    } else {
      uiService.toast({
        text: {
          p1: 'Partner',
          p2: isAccountAsPartner
            ? $scope.getAccount(idPartner).getName()
            : $scope.getPartner(idPartner).getName(),
          p3: 'already exist'
        },
        warn: true
      });
    }
  };

  $scope.changePartnerFee = (idPartner, partnerReferralFee) => {
    $scope.Model.currentTicket.partnersReferralFee[idPartner] = partnerReferralFee;
    $timeout(() => {
      $scope.toggleChanges();
    });
  };

  $scope.canSeePartner = (idPartner) => {
    const idPartners = _.map($scope.Model.availablePartners, 'id');
    return idPartners.indexOf(idPartner) > -1;
  };

  /*
   * Ticket Edit ~ Add/Edit new contact
   * --------------------------------------------------------------------------------
   */
  $scope.getContact = (idContact) =>
    _.find($scope.Model.availableContacts || [], (c) => c?.id === idContact);

  $scope.filledContactDetails = (contact) => {
    const ticketContact = helperService.getTicketContactModel();
    const callingCode =
      $rootScope.CurrentOrganization?.organization?.location?.callingCode[0] || '';
    ticketContact.id = contact?.id || undefined;
    ticketContact.isCompany = contact?.isCompany || false;
    ticketContact.name = contact?.isCompany
      ? contact?.company?.information?.name || ''
      : contact?.person?.information?.firstName || '';
    ticketContact.familyName =
      !contact.isCompany && contact?.person?.information?.familyName
        ? contact.person.information.familyName
        : '';
    ticketContact.phoneCode = contact?.isCompany
      ? contact.company.contact.phoneCode || callingCode
      : contact?.person?.contact?.primaryCode || callingCode;
    ticketContact.phone = contact?.isCompany
      ? contact?.company?.contact?.phone || ''
      : contact?.person?.contact?.primary;
    ticketContact.email = contact?.isCompany
      ? contact?.company?.contact?.email || ''
      : contact?.person?.contact?.email;
    const contactType = $scope.getIdLabelByContact(contact?.id);
    ticketContact.type = contactType;
    return ticketContact;
  };

  $scope.contactAdd = (isCompany) => {
    const ticketContact = $scope.filledContactDetails({});
    ticketContact.isCompany = isCompany;
    $scope.Model.ticketContacts.push(ticketContact);
  };

  $scope.contactEdited = () => {
    if (
      $scope.Model.ticketContacts[0]?.isCompany &&
      $scope.Model.ticketContacts[0]?.name &&
      !$scope.Model.currentTicket?.name
    ) {
      $scope.Model.currentTicket.name = $scope.Model.ticketContacts[0]?.name;
    }
    if (
      !$scope.Model.ticketContacts[0]?.isCompany &&
      $scope.Model.ticketContacts[0]?.name &&
      $scope.Model.ticketContacts[0]?.familyName &&
      !$scope.Model.currentTicket?.name
    ) {
      $scope.Model.currentTicket.name = `${$scope.Model.ticketContacts[0]?.name} ${$scope.Model.ticketContacts[0]?.familyName}`;
    }
    $scope.toggleChanges();
  };

  $scope.contactDelete = ($event, contactToDelete) => {
    const idx = _.indexOf($scope.Model.ticketContacts || [], contactToDelete);
    if (contactToDelete?.id && idx > -1) {
      $mdDialog
        .show({
          targetEvent: $event !== null ? $event : '',
          locals: {
            ticketContact: contactToDelete
          },
          template,
          controllerAs: '$ctrl',
          controller(ticketContact) {
            const ctrl = this;
            ctrl.ticketContact = ticketContact;
            ctrl.ticketContactName = ctrl.ticketContact?.isCompany
              ? ctrl.ticketContact?.name || 'N/A'
              : `${ctrl.ticketContact?.name || 'N/A'} ${
                  ctrl.ticketContact?.familyName || 'N/A'
                }`;

            ctrl.confirm = () => {
              $mdDialog.hide();
            };
            ctrl.cancel = () => {
              $mdDialog.cancel();
            };
          }
        })
        .then(() => {
          $scope.Model.ticketContacts.splice(idx, 1);
          $scope.toggleChanges();
        });
    }
    if (!contactToDelete?.id && idx > -1) {
      $scope.Model.ticketContacts.splice(idx, 1);
      $scope.toggleChanges();
    }
  };

  $scope.getIdLabel = (idLabel) =>
    _.find($scope.Model.availableContactLabels || [], (l) => l?.id === idLabel);

  $scope.getIdLabelByContact = (idContact) => {
    let type = _.find(
      $scope.Model.currentTicket?.ticketClientTypes || [],
      (t) => t?.idContact === idContact
    );
    if (!type) {
      type = _.find(
        $scope.Model.currentTicket?.ticketContactTypes || [],
        (t) => t?.idContact === idContact
      );
    }
    return type?.idLabel || helperService.getIdLabelsOfClient()[0];
  };

  $scope.isFieldExist = (idField) =>
    ticketService.isFieldExist($scope.Model.availableFields, idField);

  $scope.deleteField = (field) => {
    $scope.Model.currentTicket.customFields.splice(
      $scope.Model.currentTicket.customFields.indexOf(field),
      1
    );
  };

  /*
   * Ticket Edit ~ If Organization has access to Broker Tools
   * --------------------------------------------------------------------------------
   */
  $scope.saveSecurityDetails = _.debounce((dataToSave) => {
    const data = dataToSave;
    if (data?.securityDetails?.length) {
      $scope.Model.currentHomeLoan.securityDetails = data.securityDetails;
    }
    if (!_.isEmpty(data.fundingWorksheets)) {
      const fLen = data?.fundingWorksheets?.fundsRequired?.length || 0;
      for (let f = 0; f < fLen; f += 1) {
        delete data.fundingWorksheets.fundsRequired[f].contractDateObject;
      }
      $scope.Model.currentHomeLoan.fundingWorksheets = data.fundingWorksheets;
    }
    if (!_.isEmpty(data)) {
      $scope.toggleChanges();
    }
  }, 500);

  /*
   * Ticket Edit ~ Switch UI Section
   * --------------------------------------------------------------------------------
   */
  $scope.hasAnyContactsAdded = () => {
    if ($scope.hasHomeLoanTools()) {
      const personContacts = _.filter(
        $scope.Model.ticketContacts || [],
        (c) => !c?.isCompany && c?.name && c?.familyName
      );
      return $scope.Model.currentTicket.isImported &&
        ($scope.Model.currentTicket.isWon || $scope.Model.currentTicket.isLost)
        ? $scope.Model.ticketContacts.length > 0
        : personContacts.length > 0;
    }
    return $scope.Model.ticketContacts.length > 0;
  };

  $scope.showSection = (section) => {
    if ($scope.hasAnyContactsAdded()) {
      if ($scope.isLenderExistingInTicketOwnersLenderAccreditations()) {
        $scope.Model.activeSection = section;
        if ($scope.Model.activeSection === 'customFields') {
          $scope.Model.currentTicket.customFields = ticketService.fieldsDifference(
            $scope.Model.availableFields,
            $scope.Model.currentTicket.customFields
          );
        }
      }
    } else {
      uiService.toast({
        text: {
          p1: 'Deal',
          p2: 'must have at least one',
          p3: $scope.hasHomeLoanTools() ? 'person as a contact' : 'contact'
        },
        warn: true
      });
    }
  };

  $scope.previous = (section) => {
    const idx = _.indexOf($scope.Model.availableSections || [], section);
    $scope.Model.activeSection =
      section !== 'dealInformation' && idx > -1
        ? $scope.Model.availableSections[idx - 1]
        : section;
    $scope.showSection($scope.Model.activeSection);
  };

  $scope.next = (section) => {
    if ($scope.hasAnyContactsAdded()) {
      if ($scope.isLenderExistingInTicketOwnersLenderAccreditations()) {
        const idx = _.indexOf($scope.Model.availableSections || [], section);
        if (idx > -1) {
          $scope.Model.activeSection =
            $scope.Model.availableSections[idx + 1] !== undefined
              ? $scope.Model.availableSections[idx + 1]
              : $scope.Model.availableSections[idx];
        }
        $scope.showSection($scope.Model.activeSection);
      }
    } else {
      uiService.toast({
        text: {
          p1: 'Deal',
          p2: 'must have at least one',
          p3: 'contact'
        },
        warn: true
      });
    }
  };

  $scope.isNextDisabled = () => {
    const idx = _.indexOf($scope.Model.availableSections || [], $scope.Model.activeSection);
    return $scope.Model.availableSections[idx + 1] === undefined;
  };

  /*
   * Ticket Edit ~ Add/Edit Team Members
   * --------------------------------------------------------------------------------
   */
  $scope.transformChip = (chip) => (angular.isObject(chip) ? chip : { value: chip });

  $scope.searchTeamMembers = (query) =>
    query ? $scope.Model.availableAccounts.filter($scope.createFilterFor(query)) : [];

  $scope.createFilterFor = (query) =>
    function filterFn(account) {
      return account.getName().toLowerCase().indexOf(query.toLowerCase()) === 0;
    };

  /*
   * Ticket Edit ~ Loan Split (non broker tools)
   * --------------------------------------------------------------------------------
   */
  $scope.saveTicketHomeLoan = (loan) => {
    $scope.Model.currentTicket.loan = loan;
    $scope.toggleChanges();
  };

  /*
   * Ticket Edit ~ Asset finance (non-tools)
   * --------------------------------------------------------------------------------
   */
  $scope.saveTicketAssetFinance = (assetFinance) => {
    $scope.Model.currentTicket.assetFinance = assetFinance;
    $scope.toggleChanges();
  };

  /*
   * Ticket Edit ~ Commercial loan
   * --------------------------------------------------------------------------------
   */
  $scope.saveTicketCommercialLoan = (commercialLoan) => {
    $scope.Model.currentTicket.commercialLoan = commercialLoan;
    $scope.toggleChanges();
  };

  /*
   * Ticket Edit ~ Conveyancing
   * --------------------------------------------------------------------------------
   */
  $scope.saveTicketConveyancing = (conveyancing) => {
    $scope.Model.currentTicket.conveyancing = conveyancing;
    $scope.toggleChanges();
  };

  /*
   * Ticket Edit ~ Insurance
   * --------------------------------------------------------------------------------
   */
  $scope.saveTicketInsurance = (insurance) => {
    $scope.Model.currentTicket.insurance = insurance;
    $scope.toggleChanges();
  };

  /*
   * Ticket Edit ~ Personal loan
   * --------------------------------------------------------------------------------
   */
  $scope.saveTicketPersonalLoan = (personalLoan) => {
    $scope.Model.currentTicket.personalLoan = personalLoan;
    $scope.toggleChanges();
  };

  /*
   * Ticket Edit ~ Real Estate
   * --------------------------------------------------------------------------------
   */
  $scope.saveTicketRealEstate = (realEstate) => {
    $scope.Model.currentTicket.realEstate = realEstate;
    $scope.toggleChanges();
  };

  $scope.isLenderSelected = (lenderName) => {
    const selectedLender = _.find(
      $scope.Model.allLenders || [],
      (l) => l?.abbr?.toLowerCase() === lenderName
    );
    return selectedLender !== undefined;
  };

  /*
   * Ticket Edit ~ Add/Remove Labels
   * --------------------------------------------------------------------------------
   */
  $scope.labelsSelected = (selectedLabels) => {
    $scope.Model.currentTicket.idLabels = selectedLabels;
    $scope.toggleChanges();
  };

  /*
   * Ticket Edit ~ Toggle Sidebar
   * --------------------------------------------------------------------------------
   */
  $scope.toggleSidebar = () => {
    $scope.Model.isSidebarMinimized = !$scope.Model.isSidebarMinimized;
    if ($scope.Model.isSidebarMinimized) {
      cookies.set('stSidebar', btoa('sidebar is minimized'), {
        path: '/'
      });
    } else {
      cookies.remove('stSidebar', { path: '/' });
    }
  };

  /*
   * Ticket Edit ~ Back
   * --------------------------------------------------------------------------------
   */
  $scope.back = () => {
    changesService.reset();
    if ($stateParams.dd === '0') {
      $state.transitionTo('board', { id: $stateParams.id });
    } else {
      $state.transitionTo('deal', {
        id: $stateParams.id,
        dd: $stateParams.dd
      });
    }
  };

  /*
   * Ticket Edit ~ Save
   * --------------------------------------------------------------------------------
   */
  $scope.save = ($event) => {
    $event.stopPropagation();
    navigationService.goToPreviousState();
  };

  /*
   * Scope Methods
   * --------------------------------------------------------------------------------
   */
  $scope.toggleChanges = () => {
    $scope.Model.isSaveReady = true;
    changesService.change();
  };

  /*
   * Register and configure Changes service
   * --------------------------------------------------------------------------------
   */
  const validate = () =>
    _.get($scope.Model.currentTicket, 'name') && _.get($scope.Model.currentTicket, 'idStage');

  const invalid = () =>
    eventService.formWarning({
      toState: $scope.Model.toState,
      toParams: $scope.Model.toParams
    });

  changesService.init();
  changesService.onValidate(validate);
  changesService.onInvalid(invalid);

  /*
   * Ticket Edit ~ Save Ticket
   * --------------------------------------------------------------------------------
   */
  const editTicket = () => {
    const deferred = $q.defer();
    let loan;
    if ($scope.hasAssetFinanceTools()) {
      loan = $scope.Model.currentAssetFinance;
    }
    if ($scope.hasHomeLoanTools()) {
      loan = $scope.Model.currentHomeLoan;
    }
    ticketService
      .editTicket({
        ticketToEdit: $scope.Model.currentTicket,
        ticketContacts: $scope.Model.ticketContacts,
        loan
      })
      .then((data) => {
        if (data.status) {
          if (!$scope.Model.currentTicket.id) {
            $scope.Model.currentTicket.id = data.id;
          }
          deferred.resolve(data);
        }
      });
    return deferred.promise;
  };

  /*
   * Ticket Edit ~ Save Changes
   * --------------------------------------------------------------------------------
   */
  const saveChanges = () => {
    if ($scope.canSave()) {
      ticketsService.clearCache();
      $scope.Model.isProcessing = true;
      $scope.Model.currentTicket.idTeamMembers = $scope.Model.currentTeamMembers.map(
        (t) => t.id
      );
      if (!$scope.Model.currentTicket.idWorkflow) {
        $scope.Model.currentTicket.idWorkflow = $scope.Model.currentWorkflow?.id;
      }

      return editTicket().then((result) => {
        if (result?.status) {
          uiService.toast({
            text: {
              p1: 'Deal',
              p2: $scope.Model.currentTicket.getName(),
              p3: 'saved successfully'
            },
            delay: 1000
          });
          return {
            result: true,
            toState: 'deal',
            toParams: {
              id: $scope.Model.currentWorkflow?.id,
              dd: result?.id
            }
          };
        }
        uiService.toast({
          text: {
            p1: 'Deal',
            p2: $scope.Model.currentTicket.getName(),
            p3: 'unsaved'
          },
          delay: 1000
        });
        return {
          result: true,
          toState: 'board',
          toParams: {
            id: result?.id
          }
        };
      });
    }
    return null;
  };

  changesService.onFinish(saveChanges);
};
